import gql from "graphql-tag";

export const POLICY_QUERY = gql`
  query PolicyQuery($slug: String!) {
    policy(slug: $slug) {
      id
      title
      content
    }
  }
`;
